import React from 'react'

const SvgRefresh = props => (
    <svg width="1em" height="1em" viewBox="0 0 22 22" {...props}>
        <path d="M11 0C7.242 0 3.85 1.925 1.833 4.95V.917H0V8.25h7.333V6.417H3.117C4.767 3.575 7.7 1.833 11 1.833c5.042 0 9.167 4.125 9.167 9.167S16.042 20.167 11 20.167c-4.4 0-8.25-3.117-8.983-7.517a.95.95 0 00-1.1-.733.95.95 0 00-.734 1.1C1.1 18.242 5.683 22 11 22c6.05 0 11-4.95 11-11S17.05 0 11 0z" />
    </svg>
)

export default SvgRefresh
